import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import {
  FaArrowLeft,
  FaUser,
  FaCrown,
  FaRocket,
  FaClipboardList,
  FaLifeRing,
  FaSignOutAlt,
} from "react-icons/fa";

import "./Account.css";
import {APP_VERSION } from "../../../common/constants";

const Account = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate("/login", { replace: true });
  };

  return (
    <div className="account-page">
      {/* ===== Top Navbar ===== */}
      <div className="account-navbar">
        <button className="back-btn" onClick={() => navigate(-1)}>
          <FaArrowLeft />
        </button>
        <span className="navbar-title">Account</span>
      </div>

      {/* ===== Menu Items ===== */}
      <div className="account-menu">
        <div className="account-item" onClick={() => navigate("/profile")}>
          <FaUser />
          <span>My Profile</span>
        </div>

        <div className="account-item" onClick={() => navigate("/my-active-plan")}>
          <FaClipboardList />
          <span>My Plan</span>
        </div>

        <div className="account-item" onClick={() => navigate("/plans")}>
          <FaCrown />
          <span>Go Premium</span>
        </div>

        <div className="account-item" onClick={() => navigate("/support")}>
          <FaLifeRing />
          <span>Support</span>
        </div>

        <div className="account-divider" />

        {/* ===== Logout ===== */}
        <div className="account-item danger" onClick={handleLogout}>
          <FaSignOutAlt />
          <span>Logout</span>
        </div>

        {/* ===== App Version ===== */}
        <div className="account-version">
          App Version {APP_VERSION}
        </div>
      </div>
    </div>
  );
};

export default Account;
